import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentCategoryQuickLinks } from './cms-component-category-quick-links.interface';

export const CMS_COMPONENT_CATEGORY_QUICK_LINKS_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentCategoryQuickLinks.ID,
    name: 'Category Quick Links',
    description: 'Horizontal scrollable quick links with automatic A/B testing support. Can be placed in any CMS outlet.',
    tags: ['navigation', 'links', 'quick-links'],
    fields: [
        // General section
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        // Quick links repeater - A/B testing field is automatically injected by the module
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quickLinks',
            title: 'Quick Links',
            default: [],
            itemName: 'Quick link',
            itemNameField: 'label',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'label',
                    title: 'Label',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'URL',
                    required: true
                }
            ]
        }
    ]
};
